import React from "react";
import { CurrentAppVersion } from "./CurrentAppVersion";

export default function FooterPublic() {
	return (
		<footer
			className="w-100 py-3 text-center"
			style={{
				background: "#000",
				color: "#fff",
				backgroundImage: "linear-gradient(to right, #373737ff, #434343)",
				minHeight: 60
			}}
		>
			<div className="container">
				<div className="container col-md-7 col-12">
					<div
						className="d-flex mx-auto mx-md-0 justify-content-between align-items-center"
						style={{ color: "white !important" }}
					>
						<img src="/logo512.png" alt="Logo" style={{ width: 40, height: 40 }} />
						<span className="" style={{ color: "white" }}>
							&copy; {new Date().getFullYear()}{" "}
							<a
								href="https://singleton.solutions/"
								target="_blank"
								rel="noreferrer"
								style={{
									color: "white",
								}}
							>
								found.center
							</a>
						</span>
						<CurrentAppVersion />
					</div>
				</div>
			</div>
		</footer>
	);
}
